export default {
    popoutBlocked: {
        datapoint: {
            name: 'PopoutBlocked',
            customData: function (source, popoutType) { return [source, popoutType]; },
        },
    },
};
export var PopoutSource;
(function (PopoutSource) {
    PopoutSource[PopoutSource["Unknown"] = 0] = "Unknown";
    PopoutSource[PopoutSource["Mail"] = 1] = "Mail";
    PopoutSource[PopoutSource["FilesHub"] = 2] = "FilesHub";
    PopoutSource[PopoutSource["PhotoHub"] = 3] = "PhotoHub";
    PopoutSource[PopoutSource["DeepLink"] = 4] = "DeepLink";
    PopoutSource[PopoutSource["Calendar"] = 5] = "Calendar";
    PopoutSource[PopoutSource["CalendarDeepLink"] = 6] = "CalendarDeepLink";
})(PopoutSource || (PopoutSource = {}));
//# sourceMappingURL=datapoints.js.map